import script from "./ThanksCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ThanksCard.vue?vue&type=script&setup=true&lang=js"

import "./ThanksCard.vue?vue&type=style&index=0&id=6f1930bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f1930bc"]])

export default __exports__